import { cva } from '../tokens/variants';

export const spinnerVariants = cva(
  'inline-block animate-spin rounded-full border-current border-solid border-r-transparent align-[-0.125em]',
  {
    variants: {
      size: {
        xs: 'h-3 w-3 border-[1.5px]',
        sm: 'h-4 w-4 border-2',
        md: 'h-5 w-5 border-2',
        lg: 'h-8 w-8 border-[3px]',
        xl: 'h-12 w-12 border-4',
      },
      tone: {
        current: 'text-current',
        brand: 'text-[var(--tk-brand-bg)]',
        muted: 'text-[var(--tk-surface-fg-muted)]',
        inverse: 'text-[var(--tk-brand-fg)]',
      },
    },
    defaultVariants: { size: 'md', tone: 'current' },
  },
);
